<template>
  <div id="app">
    <index />
    <!-- <swiper/> -->
    <keep-alive include="Home">
      <router-view />
    </keep-alive>
    <bottom />
  </div>
</template>

<script>
import index from "@/views/home/index";
import Swiper from "@/views/home/Swiper";
import Bottom from "@/components/common/bottom/Bottom";
export default {
  name: "App",
  components: {
    index,
    Swiper,
    Bottom,
  },
  data() {
    return {

    };
  },
  // computed: {
  //   currentRoute() {
  //     return window.location.href.split("#")[1];
  //   },
  // },
  // watch: {
  //   currentRoute: {
  //     handler(val) {
  //       console.log("val1111", val);
  //     },
  //     immediate: true,
  //     deep: true,
  //   },
  // },

};
</script>

<style>
html,
body {
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  /* min-width:1200px */
}
</style>
